import React from "react";

const JobsTableSkeleton = () => {
    const skeletonRows = Array(6).fill(null);

    return (
        <table className="jobs-table">
            <thead>
                <tr>
                    <th></th>
                    <th>Company</th>
                    <th>Location</th>
                    <th>Title</th>
                    <th>Type</th>
                    <th>Experience</th>
                    <th>Category</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {skeletonRows.map((_, index) => (
                    <tr key={index}>
                        <td>
                            <div className="w-4 h-4 bg-gray-200 rounded-md"></div>
                        </td>
                        <td>
                            <div className="h-4 bg-gray-200 rounded w-24"></div>
                        </td>
                        <td>
                            <div className="h-4 bg-gray-200 rounded w-20"></div>
                        </td>
                        <td>
                            <div className="h-4 bg-gray-200 rounded w-32"></div>
                        </td>
                        <td>
                            <div className="h-4 bg-gray-200 rounded w-16"></div>
                        </td>
                        <td>
                            <div className="h-4 bg-gray-200 rounded w-20"></div>
                        </td>
                        <td>
                            <div className="h-6 bg-gray-200 rounded-full w-20"></div>
                        </td>
                        <td>
                            <div className="h-8 bg-gray-200 rounded w-24"></div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default JobsTableSkeleton;
